<template>
  <div v-if="dialogLoading" class="overlay">
    <Loader />
  </div>
  <Loader v-if="loading"></Loader>
  <div class="full-width-container">
    <div class="center-content">
      <Card class="w-full">
        <template v-slot:content>
          <h1 class="page-title">Caricamento File Fornitori</h1>
          <div class="flex align-items-center flex-column">
            <Dropdown v-if="Fornitori && Fornitori.length > 0" v-model="selectedFornitore"
              :options="fornitoriWithOptions" placeholder="Seleziona un Fornitore" class="w-full md:w-14rem mb-2" />
            <div v-else>Loading...</div>
            <div class="button-wrapper">
              <span class="label">{{
                fileToUpload.length == 0
                  ? "Seleziona File"
                  : fileToUpload.length + " files"
              }}</span>
              <input id="upload" type="file" ref="fileInputRef" @change="handleFileUpload($event)"
                accept=".xml, .csv, .xlsx" multiple />
            </div>
            <div v-show="validationErrors.files && submitted" class="p-error">
              Campo richiesto.
            </div>
            <div v-show="validationErrors.type && submitted" class="p-error">
              Formato non consentito
            </div>
          </div>
          <div class="text-center">
            <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
          </div>
          <Button @click="caricaFileFornitore" label="Carica File" :disabled="!selectedFornitore"
            class="upload-button" />
        </template>
        <template v-slot:footer>
          <button @click="toggleLegend" class="toggle-legend-button">
            {{ showLegend ? "Nascondi Legenda" : "Mostra Leggenda" }}
          </button>
          <transition name="collapse">
            <div v-if="showLegend" class="legend-box">
              <h4>Legenda Formato File:</h4>
              <div class="legend">
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>A2A = Caricare File XML</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Antares = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Cei = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Eco = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Energia Sociale = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Europe = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Onergy = Caricare file CSV</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Pegaso = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Soluzione Energia = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Unico = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Union = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Newatt = Caricare file XLSX</span>
                </div>
                <div class="legend-item">
                  <div class="legend-dot"></div>
                  <span>Ecotrade = Caricare file XLSX</span>
                </div>
              </div>
            </div>
          </transition>
        </template>
      </Card>
    </div>
  </div>
  <div class="center-content">
    <Card class="history-card" @click="loadStorico" v-if="!storicoLoaded">
      <template v-slot:header>
        <br />
        <h3 class="page-title">Storico File Caricati</h3>
        <p class="click-to-load">Clicca per caricare i dati</p>
      </template>
    </Card>
    <Card class="history-card" v-else>
      <template v-slot:header>
        <br />
        <h3 class="page-title">Storico File Caricati</h3>
      </template>
      <template v-slot:content>
        <div class="fornitori-navbar">
  <div class="fornitori-container">
    <span v-for="fornitore in FornitoriNomi" 
          :key="fornitore" 
          @click="filterFilesByFornitore(fornitore)"
          :class="['fornitore-tag', { 'active': fornitore === selectedFornitoreNome }]">
      {{ fornitore }}
    </span>
  </div>
</div>
        <table class="file-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Data di caricamento</th>
              <th>Fornitore</th>
              <th>Utente</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in filteredFiles" :key="file.file_name">
              <td>{{ file.file_name }}</td>
              <td>{{ file.created_at }}</td>
              <td>{{ file.name_fornitore }}</td>
              <td>
                <span class="email">{{ file.email }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </Card>
  </div>
  <div class="center-content">
    <Card class="history-card" @click="loadConteggio" v-if="!conteggioLoaded">
      <template v-slot:header>
        <br />
        <h3 class="page-title">Totale File Elaborati Per Fornitore</h3>
        <p class="click-to-load">Clicca per caricare i dati</p>
      </template>
    </Card>
    <Card class="history-card" v-else>
      <template v-slot:header>
        <br />
        <h3 class="page-title">Totale File Elaborati Per Fornitore</h3>
      </template>
      <template v-slot:content>
        <table class="file-table">
          <thead>
            <tr>
              <th>Fornitore</th>
              <th>File</th>
              <th>Ultima Modifica</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(fornitore, index) in fornitoriConteggio" :key="index">
              <td>
                <span class="clickable-fornitore" @click="openFornitoreDialog(fornitore)">
                  {{ fornitore.provider }}
                </span>
              </td>
              <td>{{ fornitore.count }}</td>
              <td>{{ fornitore.last_modified }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </Card>
  </div>
  <div class="center-content">
    <Card class="history-card" @click="loadGrafici" v-if="!graficiLoaded">
      <template v-slot:header>
        <br />
        <h3 class="page-title">File Elaborati Per Fornitore</h3>
        <p class="click-to-load">Clicca per caricare i dati</p>
      </template>
    </Card>
    <Card class="history-card" v-else>
      <template v-slot:header>
        <br />
        <h3 class="page-title">File Elaborati Per Fornitore</h3>
      </template>
      <template v-slot:content>
        <div class="chart-container">
          <div class="chart-item">
            <canvas ref="pieChartEE"></canvas>
          </div>
          <div class="chart-item">
            <canvas ref="pieChartGAS"></canvas>
          </div>
        </div>
        <br />
        <div v-if="showDropdown" class="provider-filter">
          <label>Seleziona Fornitore: </label>
          <Dropdown v-model="selectedProvider" :options="uniqueProviders" placeholder="Seleziona un fornitore"
            class="w-full md:w-14rem mb-4" @change="filterDataByProvider" />
        </div>
        <div class="chart-container">
          <div class="bar-chart-item">
            <canvas ref="barChart"></canvas>
          </div>
        </div>
      </template>
    </Card>
  </div>
  <div class="center-content">
    <Card class="history-card" @click="initFattureMancanti" v-if="!fattureMancantiLoaded">
      <template v-slot:header>
        <br />
        <h3 class="page-title">Fatture non mappate</h3>
        <p class="click-to-load">Clicca per caricare i dati</p>
      </template>
    </Card>
    <Card class="history-card" v-else>
      <template v-slot:header>
        <br />
        <h3 class="page-title">Fatture non mappate</h3>
        <div class="tipo-fatture-buttons">
          <button 
            @click="loadFattureMancantiByType('EE')" 
            :class="['btn-tipo-fatture', { active: selectedTipoFatture === 'EE' }]"
          >
            Energia Elettrica
          </button>
          <button 
            @click="loadFattureMancantiByType('GAS')" 
            :class="['btn-tipo-fatture', { active: selectedTipoFatture === 'GAS' }]"
          >
            Gas
          </button>
        </div>
      </template>
      <template v-slot:content>
        <div v-if="selectedTipoFatture">
          <table class="file-table">
            <thead>
              <tr>
                <th>Fornitore</th>
                <th>Totale Fatture Mancanti</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="fornitore in fattureMancanti" :key="fornitore.cod_fornitore">
                <td>{{ fornitore.ragione_sociale }}</td>
                <td>{{ fornitore.totale_fatture_mancanti }}</td>
                <td>
                  <button @click="showFattureDetails(fornitore)" class="btn-action view-details">
                    Visualizza Dettagli
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="select-type-message">
          Seleziona il tipo di fatture da visualizzare
        </div>
      </template>
    </Card>
  </div>
  <Dialog v-model:visible="dialogVisible" header="File Elaborati Fornitore" :modal="true" :closable="true"
    :style="{ width: '80vw', overflow: 'auto' }">
    <div v-if="selectedDialogFiles.length">
      <table class="file-details-table">
        <thead>
          <tr>
            <th>File Name</th>
            <th>POD</th>
            <th>PDR</th>
            <th>Totale Fattura</th>
            <th>Data Emissione</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, index) in selectedDialogFiles" :key="index">
            <td>{{ file.file_name }}</td>
            <td>{{ file.POD }}</td>
            <td>{{ file.PDR }}</td>
            <td>{{ file.TOTALE_FATTURA }}</td>
            <td>{{ file["Data Emissione"] }}</td>
            <td>
              <button @click="
                downloadFileFornitore(
                  file.file_name,
                  selectedDialogFornitore.provider
                )
                " class="btn-action download">
                Scarica
              </button>
              <button @click="
                viewFileFornitore(
                  file.file_name,
                  selectedDialogFornitore.provider
                )
                " class="btn-action view-details">
                Visualizza Dettagli
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p v-else style="text-align: center; padding: 10px">
      Nessun file disponibile.
    </p>
  </Dialog>
  <Dialog v-model:visible="detailsDialogVisible" header="Dettaglio Fatture Mancanti" :modal="true"
    :style="{ width: '70vw' }">
    <div v-if="selectedFornitoreDetails">
      <div class="header-actions">
        <h4>{{ selectedFornitoreDetails.ragione_sociale }}</h4>
        <Button label="Esporta Excel" icon="pi pi-file-excel" @click="exportToExcel" class="export-button" />
      </div>

      <div class="date-filters">
        <div class="date-filter">
          <label>Data da:</label>
          <Calendar v-model="dateFilter.from" dateFormat="dd/mm/yy" :showIcon="true" :maxDate="dateFilter.to" />
        </div>
        <div class="date-filter">
          <label>Data a:</label>
          <Calendar v-model="dateFilter.to" dateFormat="dd/mm/yy" :showIcon="true" :minDate="dateFilter.from" />
        </div>
        <Button label="Resetta Filtri" @click="resetDateFilters" class="reset-button" severity="secondary" />
      </div>

      <table class="file-table">
        <thead>
          <tr>
            <th>Numero Fattura</th>
            <th>Data Emissione</th>
            <th>Totale Fattura</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fattura in filteredFatture" :key="fattura.numero">
            <td>{{ fattura.numero }}</td>
            <td>{{ formatDate(fattura.data_emissione) }}</td>
            <td>€ {{ formatCurrency(fattura.totale_fattura) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total-row">
            <td colspan="2" class="text-right"><strong>Totale:</strong></td>
            <td>€ {{ formatCurrency(calcolaTotaleFatture(filteredFatture)) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </Dialog>
</template>

<script>
import { ref, getCurrentInstance, onMounted, computed } from "vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import Chart from "chart.js/auto";
import Service from "@/services/ask-caricamento-file/caricamento-file";
import Loader from "@/components/Loader.vue";
import Dialog from "primevue/dialog";
import Calendar from 'primevue/calendar';
import * as XLSX from 'xlsx';

export default {
  components: {
    Loader,
    Dialog,
    Calendar,
  },
  setup() {
    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$eventBus);
    const selectedDialogFiles = ref([]);
    const fileToUpload = ref([]);
    const currentUser = ref(null);
    const uploadedFiles = ref([]);
    const allowedType = ["xml", "csv", "xlsx"];
    const validationErrors = ref({});
    const submitted = ref(false);
    const loading = ref(false);
    const Fornitori = ref([]);
    const contenutoInbox = ref({ files: [] });
    const selectedFornitore = ref(null);
    const selectedFornitoreNome = ref(null);
    const searchQuery = ref("");
    const FornitoriNomi = ref([]);
    const showLegend = ref(false);
    const fornitoriConteggio = ref([]);
    const dialogVisible = ref(false);
    const selectedDialogFornitore = ref({});
    const dialogLoading = ref(false);
    const pieChart = ref(null);
    const pieChartEE = ref(null);
    const pieChartGAS = ref(null);
    const fileData = ref([]);
    const barChart = ref(null);
    const monthlyData = ref([]);
    const selectedProvider = ref(null);
    const showDropdown = ref(false);
    const chartDataLoaded = ref(false);
    const dropdownDataLoaded = ref(false);
    const dataArray = Array.isArray(monthlyData.value) ? monthlyData.value : [];
    const uniqueProviders = computed(() => {
      return [...new Set(monthlyData.value.map((item) => item.provider))];
    });
    let barChartInstance = ref(null);
    const fattureMancanti = ref([]);
    const detailsDialogVisible = ref(false);
    const selectedFornitoreDetails = ref(null);
    const dateFilter = ref({
      from: null,
      to: null
    });
    const storicoLoaded = ref(false);
    const conteggioLoaded = ref(false);
    const graficiLoaded = ref(false);
    const fattureMancantiLoaded = ref(false);
    const selectedTipoFatture = ref(null);
    const directoriesFattureGrezze = ref([]);
    const selectedDirectoryFattureGrezze = ref(null);
    const fileFattureGrezze = ref(null);
    const fileFattureGrezzeLabel = ref("Nessun file selezionato");
    const isUploadingFattureGrezze = ref(false);
    const uploadMessageFattureGrezze = ref("");
    const uploadStatusFattureGrezze = ref("info");
    const loadingDirectories = ref(false);
    const fileInputFattureGrezze = ref(null);
    const fileInputRef = ref(null);

    onMounted(async () => {
      try {
        const fornitori = await service.getListaFornitori();
        Fornitori.value = fornitori;
        
        await loadDirectoriesFattureGrezze();
      } catch (error) {
        console.error("Errore durante l'inizializzazione:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante l'inizializzazione della pagina.",
        });
      }
    });

    const toggleLegend = () => {
      showLegend.value = !showLegend.value;
    };

    const fetchContenutoInboxFornitori = async () => {
      try {
        const contenutoInboxResponse =
          await service.getContenutoInboxFornitori();
        contenutoInbox.value = contenutoInboxResponse;
      } catch (error) {
        console.error(
          "Errore durante il recupero del contenuto della cartella Inbox dei fornitori:",
          error
        );
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Errore durante il recupero del contenuto della cartella Inbox dei fornitori",
        });
      }
    };

    const fetchFornitoriConteggio = async () => {
      try {
        const response = await service.getListaFornitoriImportati();
        fornitoriConteggio.value = response;
      } catch (error) {
        console.error(
          "Errore durante il recupero del conteggio dei file per fornitore:",
          error
        );
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Errore durante il recupero del conteggio dei file per fornitore",
        });
      }
    };

    const fetchUploadedFiles = async () => {
      try {
        const filesResponse = await service.getAllUploadedFattureFornitori();
        const formattedFiles = filesResponse.map((file) => {
          const formattedDate = moment(file.created_at).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          return {
            ...file,
            created_at: formattedDate,
          };
        });
        uploadedFiles.value = formattedFiles;
      } catch (error) {
        console.error("Errore durante il recupero dei file caricati:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei file caricati",
        });
      }
    };

    const handleFileUpload = (evt) => {
      evt.preventDefault();
      submitted.value = false;
      const files = evt.target.files;
      const validFiles = [];
      const maxSize = 500000 * 1024;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (file.size <= maxSize) {
          validFiles.push(file);
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Il file ${file.name} supera la dimensione massima consentita (500 MB)`,
          });
        }
      }
      fileToUpload.value = validFiles;
    };

    const getListaFornitoriNomi = async () => {
      try {
        const response = await service.getListaFornitoriNomi();
      } catch (error) {
        console.error(
          "Errore durante il recupero dell'elenco dei nomi dei fornitori:",
          error
        );
      }
    };

    const caricaFileFornitore = () => {
      submitted.value = true;

      if (fileToUpload.value.length === 0) {
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Seleziona almeno un file da caricare",
        });
        return;
      }

      loading.value = true;

      const numFilesToUpload = fileToUpload.value.length;
      let numFilesUploaded = 0;

      fileToUpload.value.forEach((file) => {
        let fornitorePrincipale = selectedFornitore.value;
        let sottocartella = "";
        if (selectedFornitore.value.includes(" - ")) {
          const [fornitore, subfolder] = selectedFornitore.value.split(" - ");
          fornitorePrincipale = fornitore;
          sottocartella = subfolder;
        }

        service
          .caricaFileFornitore(fornitorePrincipale, [file], sottocartella)
          .then((response) => {
            numFilesUploaded++;
            const message = response.message || "File Caricato con successo";
            
            if (numFilesUploaded === numFilesToUpload) {
              fileToUpload.value = [];
              selectedFornitore.value = null;
              submitted.value = false;
              
              if (fileInputRef.value) {
                fileInputRef.value.value = '';
              }
              
              toast.add({
                severity: "success",
                summary: "Successo",
                detail: message,
              });
              setTimeout(() => {
                fetchContenutoInboxFornitori();
                window.location.reload();
              }, 5000);
            }
          })
          .catch((error) => {
            toast.add({
              severity: "error",
              summary: "Errore",
              detail: `Si è verificato un errore durante il caricamento del file ${file.name}`,
            });
          })
          .finally(() => {
            if (numFilesUploaded === numFilesToUpload) {
              loading.value = false;
            }
          });
      });
    };

    const validateForm = () => {
      if (fileToUpload.value.length === 0) {
        validationErrors.value["files"] = true;
        delete validationErrors.value["type"];
      } else {
        delete validationErrors.value["files"];
      }

      if (fileToUpload.value.length > 0) {
        const valid = [...fileToUpload.value].every((file) => {
          const extension = file.name.split(".").pop().toLowerCase();
          return allowedType.includes(extension);
        });
        if (valid) delete validationErrors.value["type"];
        else validationErrors.value["type"] = true;
      }

      return !Object.keys(validationErrors.value).length;
    };

    const fornitoriWithOptions = computed(() => {
      return Fornitori.value.flatMap((fornitore) => {
        let options = [];
        if (fornitore.subdirectories.length === 0) {
          options.push(fornitore.name);
        } else {
          if (fornitore.subdirectories.includes("EE")) {
            options.push(`${fornitore.name} - EE`);
          }
          if (fornitore.subdirectories.includes("GAS")) {
            options.push(`${fornitore.name} - GAS`);
          }
        }
        return options;
      })
    });

    const filterFilesByFornitore = (fornitore) => {
      if (fornitore === selectedFornitoreNome.value) {
        selectedFornitoreNome.value = null;
      } else {
        selectedFornitoreNome.value = fornitore;
      }
      updateFilteredFiles();
    };

    const updateFilteredFiles = () => {
      if (!selectedFornitoreNome.value) {
        filteredFiles.value = uploadedFiles.value;
      } else {
        filteredFiles.value = uploadedFiles.value.filter(
          (file) => file.name_fornitore === selectedFornitoreNome.value
        );
      }
    };

    const filteredFiles = computed(() => {
      if (!selectedFornitoreNome.value) {
        return uploadedFiles.value;
      }
      return uploadedFiles.value.filter(
        (file) => file.name_fornitore === selectedFornitoreNome.value
      );
    });

    const fetchFornitoriNomi = async () => {
      try {
        const fornitoriNomi = await service.getListaFornitoriNomi();
        FornitoriNomi.value = fornitoriNomi;
      } catch (error) {
        console.error(
          "Errore durante il recupero dell'elenco dei nomi dei fornitori:",
          error
        );
        toast.add({
          severity: "error",
          summary: "Errore",
          detail:
            "Errore durante il recupero dell'elenco dei nomi dei fornitori",
        });
      }
    };

    const openFornitoreDialog = async (fornitore) => {
      dialogLoading.value = true;
      selectedDialogFiles.value = [];
      selectedDialogFornitore.value = fornitore;

      try {
        const response = await service.getListaFileFornitore(
          fornitore.provider
        );
        if (response && Array.isArray(response.files)) {
          selectedDialogFiles.value = response.files.sort((a, b) => {
            return (
              new Date(a["Data Emissione"]) - new Date(b["Data Emissione"])
            );
          });
        } else {
          selectedDialogFiles.value = [];
        }

        dialogVisible.value = true;
      } catch (error) {
        console.error("Errore durante il recupero dei file:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il caricamento dei file.",
        });
      } finally {
        dialogLoading.value = false;
      }
    };

    const downloadFileFornitore = async (fileName, provider) => {
      try {
        const response = await service.downloadFileFromFornitore(
          provider,
          fileName
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Errore durante il download del file:", error);
      }
    };

    const viewFileFornitore = async (fileName) => {
      try {
        const response = await service.viewFileFornitore(fileName);

        if (
          response.data &&
          response.data.content &&
          response.data.content.length > 0
        ) {
          const data = response.data.content;

          const tableHeaders = Object.keys(data[0])
            .map((key) => `<th>${key}</th>`)
            .join("");

          const tableRows = data
            .map((row) => {
              return `<tr>${Object.values(row)
                .map((value) => `<td>${value !== null ? value : ""}</td>`)
                .join("")}</tr>`;
            })
            .join("");

          const htmlContent = `
        <html>
          <head>
            <title>Dettagli del File</title>
            <style>
              table {
                width: 100%;
                border-collapse: collapse;
              }
              table, th, td {
                border: 1px solid black;
              }
              th, td {
                padding: 8px;
                text-align: left;
              }
              th {
                background-color: #f2f2f2;
              }
            </style>
          </head>
          <body>
            <h1>Dettagli del File: ${fileName}</h1>
            <table>
              <thead>
                <tr>${tableHeaders}</tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </body>
        </html>
      `;

          const newWindow = window.open("", "_blank");
          if (newWindow) {
            newWindow.document.write(htmlContent);
            newWindow.document.close();
          } else {
            console.error("Impossibile aprire una nuova finestra.");
          }
        } else {
          console.error("Nessun contenuto trovato per questo file.");
        }
      } catch (error) {
        console.error(
          "Errore durante la visualizzazione dei dettagli del file:",
          error
        );
      }
    };

    const fetchFornitoriSplittedData = async () => {
      try {
        const response = await service.getListaFornitoriSplitted();

        const chartData = response.reduce((acc, item) => {
          if (!acc[item.provider]) {
            acc[item.provider] = {
              EE: 0,
              GAS: 0,
              EE_db_count: 0,
              GAS_db_count: 0,
            };
          }

          if (item.EE > 0) {
            acc[item.provider].EE += item.EE;
            acc[item.provider].EE_db_count += item.EE_db_count || 0;
          }

          if (item.GAS > 0) {
            acc[item.provider].GAS += item.GAS;
            acc[item.provider].GAS_db_count += item.GAS_db_count || 0;
          }

          return acc;
        }, {});

        const formattedData = Object.keys(chartData).map((provider) => ({
          provider,
          EE: chartData[provider].EE || 0,
          GAS: chartData[provider].GAS || 0,
          EE_db_count: chartData[provider].EE_db_count || 0,
          GAS_db_count: chartData[provider].GAS_db_count || 0,
        }));

        renderPieChart(formattedData);
        renderBarChart(formattedData);

        chartDataLoaded.value = true;
        checkIfReadyToShowDropdown();
      } catch (error) {
        console.error(
          "Errore durante il caricamento dei dati del grafico:",
          error
        );
      }
    };

    const renderPieChart = (data) => {
      const eeData = data.filter((item) => item.EE > 0);
      const gasData = data.filter((item) => item.GAS > 0);

      if (pieChartEE.value) {
        const ctxEE = pieChartEE.value.getContext("2d");
        ctxEE.clearRect(0, 0, pieChartEE.value.width, pieChartEE.value.height);
        new Chart(ctxEE, {
          type: "pie",
          data: {
            labels: eeData.map((item) => item.provider),
            datasets: [
              {
                label: "File EE",
                data: eeData.map((item) => item.EE),
                backgroundColor: [
                  "#36A2EB",
                  "#4BC0C0",
                  "#9966FF",
                  "#FF6384",
                  "#FF9F40",
                  "#FFCE56",
                ],
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: (tooltipItem) => {
                    const provider = eeData[tooltipItem.dataIndex].provider;
                    const fileCount = eeData[tooltipItem.dataIndex].EE;
                    const dbCount = eeData[tooltipItem.dataIndex].EE_db_count;
                    return `${provider}: ${fileCount} File, ${dbCount} POD`;
                  },
                },
              },
            },
          },
        });
      }

      if (pieChartGAS.value) {
        const ctxGAS = pieChartGAS.value.getContext("2d");
        ctxGAS.clearRect(
          0,
          0,
          pieChartGAS.value.width,
          pieChartGAS.value.height
        );
        new Chart(ctxGAS, {
          type: "pie",
          data: {
            labels: gasData.map((item) => item.provider),
            datasets: [
              {
                label: "File GAS",
                data: gasData.map((item) => item.GAS),
                backgroundColor: [
                  "#FFCE56",
                  "#FF9F40",
                  "#FF6384",
                  "#4BC0C0",
                  "#9966FF",
                  "#36A2EB",
                ],
              },
            ],
          },
          options: {
            responsive: true,
            plugins: {
              tooltip: {
                callbacks: {
                  label: (tooltipItem) => {
                    const provider = gasData[tooltipItem.dataIndex].provider;
                    const fileCount = gasData[tooltipItem.dataIndex].GAS;
                    const dbCount = gasData[tooltipItem.dataIndex].GAS_db_count;
                    return `${provider}: ${fileCount} File, ${dbCount} PDR`;
                  },
                },
              },
            },
          },
        });
      }
    };

    const fetchMonthlyDataForProvider = async (providerName) => {
      try {
        const response = await service.getMonthlyDataForAllProviders(
          providerName
        );

        const startDate = moment().subtract(1, "year").startOf("year");
        const endDate = moment().endOf("year");
        const allMonths = generateAllMonths(startDate, endDate);

        const monthlyDataMap = {};
        allMonths.forEach((month) => {
          monthlyDataMap[month] = { fileCount: 0, podPdrCount: 0 };
        });

        response.forEach((item) => {
          try {
            const month = moment(item.month, "MM/YYYY").format("MM/YYYY");

            if (!monthlyDataMap[month]) {
              console.warn(`Mese non trovato nella mappa: ${month}`);
              return;
            }

            monthlyDataMap[month] = {
              fileCount: parseInt(item.fileCount) || 0,
              podPdrCount: parseInt(item.podPdrCount) || 0
            };
          } catch (error) {
            console.error(`Errore nell'elaborazione del mese: ${item.month}`, error);
          }
        });

        const sortedData = allMonths.map((month) => ({
          month,
          fileCount: monthlyDataMap[month].fileCount,
          podPdrCount: monthlyDataMap[month].podPdrCount,
        }));

        const formattedData = {
          labels: sortedData.map((item) => item.month),
          fileCounts: sortedData.map((item) => item.fileCount),
          podPdrCounts: sortedData.map((item) => item.podPdrCount),
        };

        renderBarChart(formattedData);
      } catch (error) {
        console.error("Errore durante il recupero dei dati mensili:", error);
      }
    };

    const updateBarChartForProvider = async (providerName) => {
      if (providerName) {
        await fetchMonthlyDataForProvider(providerName);
      }
    };

    const renderBarChart = (data) => {
      if (!barChart.value) return;

      const ctx = barChart.value.getContext("2d");
      if (barChartInstance.value) {
        barChartInstance.value.destroy();
      }

      const dataArray = Array.isArray(data) ? data : [];

      const startYear = moment().subtract(1, "year").year();
      const currentYear = moment().year();
      const monthsFixed = [
        ...Array.from(
          { length: 12 },
          (_, i) => `${String(i + 1).padStart(2, "0")}/${startYear}`
        ),
        ...Array.from(
          { length: 12 },
          (_, i) => `${String(i + 1).padStart(2, "0")}/${currentYear}`
        ),
      ];

      const formattedData = monthsFixed.map((month) => {
        const item = filteredData.value.find((d) =>
          moment(d.month, "MM/YYYY").isSame(moment(month, "MM/YYYY"))
        );
        return {
          month,
          fileCount: item ? item.fileCount : 0,
          podPdrCount: item ? item.podPdrCount : 0,
        };
      });

      const chartLabels = formattedData.map((item) => item.month);
      const fileCounts = formattedData.map((item) => item.fileCount);
      const podPdrCounts = formattedData.map((item) => item.podPdrCount);

      barChartInstance.value = new Chart(ctx, {
        type: "bar",
        data: {
          labels: chartLabels,
          datasets: [
            {
              label: "File Caricati",
              data: fileCounts,
              backgroundColor: "rgba(54, 162, 235, 0.8)",
              borderColor: "#007bff",
              borderWidth: 2,
              barThickness: 20,
            },
            {
              label: "POD/PDR",
              data: podPdrCounts,
              backgroundColor: "rgba(255, 99, 132, 0.7)",
              borderColor: "#ff4d6b",
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              display: true,
              position: "top",
            },
          },
          scales: {
            x: {
              title: { display: true, text: "Mesi" },
              ticks: { maxRotation: 45, minRotation: 45 },
            },
            y: {
              title: { display: true, text: "Conteggio" },
              beginAtZero: true,
            },
          },
        },
      });
    };

    const fetchDropdownData = async () => {
      try {
        const response = await service.getListaFornitoriNomi();
        FornitoriNomi.value = response;
        dropdownDataLoaded.value = true;
        checkIfReadyToShowDropdown();
      } catch (error) {
        console.error("Errore nei dati del dropdown:", error);
      }
    };

    const checkIfReadyToShowDropdown = () => {
      if (chartDataLoaded.value && dropdownDataLoaded.value) {
        showDropdown.value = true;
      }
    };

    const fetchMonthlyData = async () => {
      try {
        const response = await service.getMonthlyDataForAllProviders();
        monthlyData.value = response;
      } catch (error) {
        console.error("Errore nel recupero dei dati mensili:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il recupero dei dati mensili.",
        });
      }
    };

    const filteredData = computed(() => {
      if (!selectedProvider.value) return [];
      return monthlyData.value.filter(
        (item) =>
          item.provider.trim().toLowerCase() ===
          selectedProvider.value.trim().toLowerCase()
      );
    });

    const filterDataByProvider = () => {
      if (!selectedProvider.value) return;

      const formattedData = monthsFixed.value.map((month) => {
        const item = filteredData.value.find((d) =>
          moment(d.month, "MM/YYYY").isSame(moment(month, "MM/YYYY"))
        );
        return {
          month,
          fileCount: item ? item.fileCount : 0,
          podPdrCount: item ? item.podPdrCount : 0,
        };
      });

      renderBarChart(formattedData);
    };

    const generateAllMonths = (startDate, endDate) => {
      const allMonths = [];
      let currentDate = moment(startDate);
      while (currentDate <= endDate) {
        allMonths.push(currentDate.format("MM/YYYY"));
        currentDate.add(1, "month");
      }
      return allMonths;
    };

    const monthsFixed = computed(() => {
      const startYear = moment().subtract(1, "year").year();
      const currentYear = moment().year();
      return [
        ...Array.from(
          { length: 12 },
          (_, i) => `${String(i + 1).padStart(2, "0")}/${startYear}`
        ),
        ...Array.from(
          { length: 12 },
          (_, i) => `${String(i + 1).padStart(2, "0")}/${currentYear}`
        ),
      ];
    });

    const initFattureMancanti = () => {
      fattureMancantiLoaded.value = true;
    };

    const loadFattureMancantiByType = async (tipo) => {
      try {
        selectedTipoFatture.value = tipo;
        const response = tipo === 'EE' 
          ? await service.getFornitoriFattureMancantiEE()
          : await service.getFornitoriFattureMancantiGAS();
        
        if (response.success) {
          fattureMancanti.value = response.data;
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: response.message
          });
        }
      } catch (error) {
        console.error(`Errore nel recupero delle fatture mancanti ${tipo}:`, error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore nel recupero delle fatture mancanti ${tipo}`
        });
      }
    };

    const showFattureDetails = async (fornitore) => {
      try {
        const response = await service.getDettaglioFattureFornitore(fornitore.cod_fornitore);
        if (response.success) {
          selectedFornitoreDetails.value = {
            ...fornitore,
            fatture: response.data
          };
          detailsDialogVisible.value = true;
          resetDateFilters();
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: response.message
          });
        }
      } catch (error) {
        console.error("Errore nel recupero dei dettagli delle fatture:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore nel recupero dei dettagli delle fatture"
        });
      }
    };

    const formatDate = (date) => {
      return moment(date).format('DD/MM/YYYY');
    };

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    };

    const calcolaTotaleFatture = (fatture) => {
      return fatture.reduce((acc, fattura) => acc + parseFloat(fattura.totale_fattura), 0);
    };

    const resetDateFilters = () => {
      dateFilter.value = {
        from: null,
        to: null
      };
    };

    const filteredFatture = computed(() => {
      if (!selectedFornitoreDetails.value) return [];

      let fatture = selectedFornitoreDetails.value.fatture;

      if (dateFilter.value.from || dateFilter.value.to) {
        fatture = fatture.filter(fattura => {
          const dataEmissione = moment(fattura.data_emissione);

          if (dateFilter.value.from && dateFilter.value.to) {
            return dataEmissione.isBetween(dateFilter.value.from, dateFilter.value.to, 'day', '[]');
          }

          if (dateFilter.value.from) {
            return dataEmissione.isSameOrAfter(dateFilter.value.from, 'day');
          }

          if (dateFilter.value.to) {
            return dataEmissione.isSameOrBefore(dateFilter.value.to, 'day');
          }

          return true;
        });
      }

      return fatture.sort((a, b) =>
        moment(b.data_emissione).valueOf() - moment(a.data_emissione).valueOf()
      );
    });

    const exportToExcel = () => {
      if (!selectedFornitoreDetails.value) return;

      const dataToExport = filteredFatture.value.map(fattura => ({
        'Numero Fattura': fattura.numero,
        'Data Emissione': formatDate(fattura.data_emissione),
        'Totale Fattura': `€ ${formatCurrency(fattura.totale_fattura)}`
      }));

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Fatture');

      const fileName = `Fatture_${selectedFornitoreDetails.value.ragione_sociale}_${moment().format('DDMMYYYY')}.xlsx`;

      XLSX.writeFile(wb, fileName);
    };

    const loadStorico = async () => {
      if (!storicoLoaded.value) {
        try {
          await fetchFornitoriNomi();
          await fetchUploadedFiles();
          storicoLoaded.value = true;
        } catch (error) {
          console.error("Errore durante il caricamento dello storico:", error);
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante il caricamento dello storico",
          });
        }
      }
    };

    const loadConteggio = async () => {
      if (!conteggioLoaded.value) {
        try {
          await fetchFornitoriConteggio();
          conteggioLoaded.value = true;
        } catch (error) {
          console.error("Errore durante il caricamento del conteggio:", error);
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante il caricamento del conteggio",
          });
        }
      }
    };

    const loadGrafici = async () => {
      if (!graficiLoaded.value) {
        try {
          await fetchFornitoriSplittedData();
          await fetchMonthlyData();
          await fetchDropdownData();
          graficiLoaded.value = true;
        } catch (error) {
          console.error("Errore durante il caricamento dei grafici:", error);
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Errore durante il caricamento dei grafici",
          });
        }
      }
    };

    const loadDirectoriesFattureGrezze = async () => {
      loadingDirectories.value = true;
      try {
        const response = await service.getSubDirectoryFattureGrezzeFornitori();
        
        if (response.status === 'success' && response.data && response.data.directories) {
          const filteredDirectories = response.data.directories.filter(dir => 
            dir.name.toLowerCase().includes('cei') || 
            dir.name.toLowerCase().includes('edistribuzione')
          );
          
          directoriesFattureGrezze.value = filteredDirectories.map(dir => {
            const pathParts = dir.name.split('/');
            let displayName = pathParts[0];
            
            if (pathParts.length > 1 && (pathParts[1].toUpperCase() === 'EE' || pathParts[1].toUpperCase() === 'GAS')) {
              displayName += ' - ' + pathParts[1].toUpperCase();
            }
            
            return {
              label: displayName,
              value: dir.path
            };
          });
          
        } else {
          console.error('Formato risposta API non valido:', response);
          directoriesFattureGrezze.value = [];
        }
        
      } catch (error) {
        console.error("Errore durante il caricamento delle directory:", error);
        toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Errore durante il caricamento delle directory",
        });
        directoriesFattureGrezze.value = [];
      } finally {
        loadingDirectories.value = false;
      }
    };

    const onDirectoryFattureGrezzeChange = () => {
      fileFattureGrezze.value = null;
      uploadMessageFattureGrezze.value = "";
    };

    const uploadFattureGrezze = async () => {
      if (!fileFattureGrezze.value || !selectedDirectoryFattureGrezze.value) {
        uploadMessageFattureGrezze.value = "Seleziona un file e una directory";
        uploadStatusFattureGrezze.value = "warning";
        return;
      }
      
      isUploadingFattureGrezze.value = true;
      uploadMessageFattureGrezze.value = "Caricamento in corso...";
      uploadStatusFattureGrezze.value = "info";
      
      try {
        const formData = new FormData();
        formData.append('file', fileFattureGrezze.value);
        
        const cleanPath = selectedDirectoryFattureGrezze.value.replace(/^\/+|\/+$/g, '');
        formData.append('directory_path', cleanPath);
                
        const result = await service.importFattureGrezzeFornitori(formData);
        
        if (result.status === 'success') {
          uploadMessageFattureGrezze.value = result.message || "File caricato con successo!";
          uploadStatusFattureGrezze.value = "success";
          fileFattureGrezze.value = null;
          
          if (fileInputFattureGrezze.value) {
            fileInputFattureGrezze.value.value = '';
          }
          
          toast.add({
            severity: "success",
            summary: "Successo",
            detail: result.message || "File caricato con successo"
          });
        } else {
          throw new Error(result.message || "Errore durante il caricamento del file");
        }
      } catch (error) {
        console.error("Errore durante il caricamento del file:", error);
        
    
        const errorMessage = error.response?.data?.message || error.message || "Errore durante il caricamento del file";
        uploadMessageFattureGrezze.value = errorMessage;
        uploadStatusFattureGrezze.value = "error";
        

        toast.add({
          severity: "error",
          summary: "Errore",
          detail: errorMessage
        });
      } finally {
        isUploadingFattureGrezze.value = false;
      }
    };

    const handleFileFattureGrezzeUpload = (evt) => {
      evt.preventDefault();
      const file = evt.target.files[0];
      if (file) {
        const extension = file.name.split('.').pop().toLowerCase();
        if (['csv', 'xlsx', 'xls'].includes(extension)) {
          fileFattureGrezze.value = file;
        } else {
          toast.add({
            severity: "error",
            summary: "Errore",
            detail: "Formato file non valido. Sono consentiti solo file CSV, XLSX e XLS"
          });
          evt.target.value = '';
          fileFattureGrezze.value = null;
        }
      } else {
        fileFattureGrezze.value = null;
      }
    };

    const getSimplifiedName = (path) => {
      if (!path) return '';
      
      if (path.toLowerCase().includes('cei')) {
        return 'cei';
      } else if (path.toLowerCase().includes('edistribuzione')) {
        return 'eDistribuzione';
      }
      
      return path;
    };

    return {
      currentUser,
      uploadedFiles,
      validationErrors,
      submitted,
      service,
      fileToUpload,
      handleFileUpload,
      allowedType,
      caricaFileFornitore,
      loading,
      Fornitori,
      FornitoriNomi,
      fornitoriWithOptions,
      fornitoriConteggio,
      getListaFornitoriNomi,
      fetchFornitoriConteggio,
      contenutoInbox,
      getCurrentDate() {
        return moment().format("YYYY-MM-DD HH:mm:ss");
      },
      selectedFornitore,
      selectedFornitoreNome,
      searchQuery,
      filterFilesByFornitore,
      filteredFiles,
      toggleLegend,
      showLegend,
      dialogVisible,
      selectedDialogFiles,
      selectedDialogFornitore,
      openFornitoreDialog,
      downloadFileFornitore,
      viewFileFornitore,
      dialogLoading,
      pieChart,
      pieChartEE,
      pieChartGAS,
      barChart,
      monthlyData,
      selectedProvider,
      uniqueProviders,
      filterDataByProvider,
      barChartInstance,
      showDropdown,
      updateBarChartForProvider,
      fattureMancanti,
      detailsDialogVisible,
      selectedFornitoreDetails,
      showFattureDetails,
      formatDate,
      formatCurrency,
      calcolaTotaleFatture,
      dateFilter,
      filteredFatture,
      resetDateFilters,
      exportToExcel,
      storicoLoaded,
      conteggioLoaded,
      graficiLoaded,
      fattureMancantiLoaded,
      loadStorico,
      loadConteggio,
      loadGrafici,
      initFattureMancanti,
      selectedTipoFatture,
      loadFattureMancantiByType,
      directoriesFattureGrezze,
      selectedDirectoryFattureGrezze,
      fileFattureGrezze,
      isUploadingFattureGrezze,
      uploadMessageFattureGrezze,
      uploadStatusFattureGrezze,
      loadingDirectories,
      loadDirectoriesFattureGrezze,
      onDirectoryFattureGrezzeChange,
      uploadFattureGrezze,
      handleFileFattureGrezzeUpload,
      getSimplifiedName,
      fileInputRef,
    };
  },
  
};
</script>

<style scoped>
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
}

.button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #544848;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
  -webkit-box-shadow: 0px 10px 13px -7px #00000050,
    5px 5px 15px 5px rgba(0, 0, 0, 0);
  box-shadow: 0px 10px 13px -7px #00000050, 5px 5px 15px 5px rgba(0, 0, 0, 0);
}

#upload {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.history-card {
  margin-top: 20px;
}

.page-title {
  font-size: 20px;
  text-align: center;
}

.file-table {
  width: 100%;
  border-collapse: collapse;
}

.file-table th,
.file-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.file-table th {
  background: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  font-weight: bold;
  color: white;
}

.file-count-select {
  display: flex;
}

.file-count-select option {
  margin-right: 10px;
}

.file-count-select-wrapper {
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
}

.file-search-input {
  margin-top: 5px;
  margin-bottom: 10px;
  width: 10%;
  padding: 8px;
  border: 1px solid #000000;
  border-radius: 5px;
  box-sizing: border-box;
}

.filter-buttons {
  margin-bottom: 10px;
}

.filter-buttons button {
  margin-right: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.filter-buttons button.active {
  background-color: #0056b3;
}

.filter-button-fornitori[data-v-38f6868c] {
  margin-right: 15px;
  margin-bottom: 10px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: #234357;
  color: #ffffff;
  border: 0.5px solid #00000012;
  cursor: pointer;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: center;
}

.filter-button-fornitori:hover {
  background-color: #908f8f;
  color: #ffffff;
}

.legend-box {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  background-color: #f9f9f9;
}

.legend {
  margin-top: 10px;
}

.legend h4 {
  margin-bottom: 5px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.legend-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: linear-gradient(0deg, #04ba2e 70%, #cad806 100%);
  margin-right: 5px;
}

.legend-dot-active {
  background-color: #0056b3;
}

.toggle-legend-button {
  margin-bottom: 2px;
  padding: 8px 16px;
  background: #1f5d38;
  color: #fff;
  border-radius: 3px;
  border: none;
  cursor: pointer;
}

.toggle-legend-button:hover {
  background-color: #468016;
}

.collapse-enter-active {
  transition: max-height 0.3s ease, padding 0.3s ease-out;
}

.collapse-enter,
.collapse-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
}

.toggle-legend-button {
  margin-bottom: 10px;
}

.clickable-fornitore {
  color: #007bff;
  cursor: pointer;
}

.clickable-fornitore:hover {
  color: #000000;
  font-weight: bold;
  font-size: 15px;
}

.file-details-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.file-details-table th,
.file-details-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.file-details-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.btn-action {
  margin: 2px;
  padding: 5px 10px;
  border: none;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
}

.btn-action.download {
  background-color: #007bff;
}

.btn-action.view-details {
  background-color: #28a745;
}

.btn-action:hover {
  opacity: 0.8;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.chart-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
}

.chart-item {
  flex: 1;
  max-width: 40%;
  text-align: center;
}

.chart-item canvas {
  width: 100%;
  height: auto;
}

.bar-chart-item {
  max-width: 100%;
  margin: 0 auto;
  text-align: center;
}

.bar-chart-item canvas {
  width: 100%;
  height: 600px;
}

.total-row {
  background-color: #f8f9fa;
  font-weight: bold;
}

.text-right {
  text-align: right;
}

.date-filters {
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%;
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
  border: 1px solid var(--border-color);
}
.date-filter {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.date-filter label {
  font-weight: 600;
  color: #133822;
  color: #133822; 
  margin: 0;
  white-space: nowrap;
}

.reset-button {
  height: fit-content;
}

.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color);
}
.export-button {
  background-color: #133822; 
  border: none;
  padding: 0.6rem 1.2rem;
  color: white;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;
  margin-left: auto; 
}

.export-button:hover {
  background-color: #0a2515;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
::deep(.p-button.p-button-icon-only) {
    width: 2.357rem;
    padding: 0.5rem 0;
    background-color: #0a2515;
}

.fornitori-navbar {
  width: 100%;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  background-color: #f8fafc;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow-x: auto;
}

.fornitori-container {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.5rem;
  min-width: max-content;
  padding: 0.25rem;
}

.fornitore-tag {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #234357;
  color: white;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: nowrap;
}

.fornitore-tag:hover {
  background-color: #1a3243;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.fornitore-tag.active {
  background-color: #133822;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  position: relative;
}

.fornitore-tag.active:after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 50%;
  transform: translateX(-50%);
  width: 30%;
  height: 3px;
  background-color: #cad806;
  border-radius: 3px;
}

.fornitori-navbar::-webkit-scrollbar {
  height: 6px;
}

.fornitori-navbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.fornitori-navbar::-webkit-scrollbar-thumb {
  background: #bbb;
  border-radius: 3px;
}

.fornitori-navbar::-webkit-scrollbar-thumb:hover {
  background: #999;
}

@media (max-width: 768px) {
  .fornitori-navbar {
    padding: 0.5rem 0.75rem;
  }
  
  .fornitore-tag {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
}
.click-to-load {
  text-align: center;
  color: #666;
  font-style: italic;
  margin-top: 1rem;
}

.history-card {
  cursor: pointer;
}

.history-card:hover {
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.tipo-fatture-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin: 1rem 0;
}

.btn-tipo-fatture {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  background-color: #f0f0f0;
}

.btn-tipo-fatture.active {
  background-color: #133822;
  color: white;
}

.btn-tipo-fatture:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.select-type-message {
  text-align: center;
  padding: 2rem;
  color: #666;
  font-style: italic;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border-radius: 4px;
  border: 1px solid #c3e6cb;
}

.alert-error {
  background-color: #f8d7da;
  color: #721c24;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
}

.alert-info {
  background-color: #d1ecf1;
  color: #0c5460;
  border-radius: 4px;
  border: 1px solid #bee5eb;
}

#uploadFattureGrezze {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>